import { render } from "./MyHome.vue?vue&type=template&id=ba5280ec&scoped=true"
import script from "./MyHome.vue?vue&type=script&lang=js"
export * from "./MyHome.vue?vue&type=script&lang=js"

import "./MyHome.vue?vue&type=style&index=0&id=ba5280ec&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba5280ec"]])

export default __exports__